<script>
  import { createEventDispatcher } from "svelte";
  import { clickOutside, Popover } from "svelte-utilities";
  import EllipsisIcon from "@local/assets/icons/ellipsis.svg";
  import { profile } from "#src/stores/auth.js";

  export let jobid;
  export let deletable = false;

  let showActions = false;
  let button;

  const dispatch = createEventDispatcher();

  $: capabilities = $profile?.profile_capabilities?.capabilities || {};

  function click(event) {
    showActions = false;
    dispatch(event, { jobid });
  }
</script>

<div class="relative" bind:this={button}>
  <button class="p-1 rounded hover:bg-gray-200" on:click={() => (showActions = !showActions)}>
    <EllipsisIcon />
  </button>
  {#if showActions}
    <Popover container={button} align="right">
      <div class="options" use:clickOutside={[button]} on:outclick={() => (showActions = false)}>
        <button class="dropdown-button-item" on:click={() => click("archive-job")}> Archive Job </button>
        {#if capabilities.clone_jobs}
          <button class="dropdown-button-item" on:click={() => click("clone-job")}> Clone Job </button>
        {/if}
        {#if capabilities.delete_jobs && deletable}
          <button class="dropdown-button-item" on:click={() => click("delete-job")}> Delete Job </button>
        {/if}
        {#if capabilities.download_json}
          <button class="dropdown-button-item" on:click={() => click("export-json")}> Export JSON </button>
        {/if}
      </div>
    </Popover>
  {/if}
</div>

<style>
  .options {
    @apply p-2 z-40 bg-white border rounded drop-shadow-lg text-xs text-black;
  }
</style>
